// contexts.js
import { createContext } from "react";

export const ClearContext = createContext();
export const AllConceptsContext = createContext();
export const ConceptsContext = createContext();
export const ConceptNameContext = createContext();
export const Loading = createContext();
